import { AddInvoiceAdjustment } from "./AddInvoiceAdjustment";
import { AddInvoiceAdjustmentTax } from "./AddInvoiceAdjustmentTax";
import { AdjustTaxes } from "./AdjustTaxes";
import { PostMigrateAdjustment } from "./PostMigrateAdjustment";


export class InvoiceAdjustment {
    public constructor(init?: Partial<InvoiceAdjustment>) {
      Object.assign(this, init);
    }
      adjustmentPosting: AddInvoiceAdjustment;
      adjustmentPostingTax: AddInvoiceAdjustmentTax[];
      adjustTaxes: AdjustTaxes;
      migrationAdjustment: PostMigrateAdjustment;
}